function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "eyrjjnahqa",
  width: "195.8%",
  height: "179.3%",
  x: "-43.8%",
  y: "-32.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.188235294 0 0 0 0 0.309803922 0 0 0 0 0.996078431 0 0 0 0.51 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "rqwakj08zb",
  d: "M12 0C5.7 0 0 4.746 0 12.085c0 4.686 3.675 10.198 11.01 16.55.57.487 1.425.487 1.995 0C20.325 22.283 24 16.771 24 12.085 24 4.745 18.3 0 12 0z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1193.000000, -94.000000) translate(898.000000, 79.000000) translate(295.000000, 15.000000) translate(6.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#eyrjjnahqa)",
  xlinkHref: "#rqwakj08zb"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#rqwakj08zb"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#304FFE",
  fillRule: "nonzero",
  d: "M12 2C6.75 2 2 5.927 2 12.001c0 3.879 3.063 8.44 9.175 13.697.475.403 1.188.403 1.662 0C18.938 20.441 22 15.88 22 12.001 22 5.927 17.25 2 12 2zm0 13.416c-2.063 0-3.75-1.646-3.75-3.659 0-2.012 1.688-3.659 3.75-3.659 2.063 0 3.75 1.647 3.75 3.66 0 2.012-1.688 3.658-3.75 3.658z",
  transform: "translate(-1193.000000, -94.000000) translate(898.000000, 79.000000) translate(295.000000, 15.000000) translate(6.000000, 3.000000)"
}))))));
function SvgMapDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDestination);
export default __webpack_public_path__ + "static/media/map-destination.7e8f0fbd6dc4cc133e11299ca555d988.svg";
export { ForwardRef as ReactComponent };